import { retrieveFromWindow } from '../../utils'
import { IAnalyticsEvent } from './event-types'

/**
 * Send analytic events for marketing purposes.
 */
class AnalyticsService {
  sendEvent({ eventName, eventCategory, eventAction, eventLabel, fields, screen }: IAnalyticsEvent): void {
    const dataLayer = retrieveFromWindow('dataLayer', undefined)

    if (!dataLayer) {
      console.error("Google Tag Manager 'dataLayer' is inaccessible.")
      
      return
    }

    const eventConfig = {
      brand: 'Youfoodz',
      event_name: eventName,
      event: 'gaEventTrigger',
      gaEventAction: eventAction,
      gaEventCategory: eventCategory,
      gaEventLabel: eventLabel,
      screen,
      tribe: 'Ecommerce',
      ...fields
    }
    
    dataLayer.push(eventConfig)
  }
}

export const analyticsService = new AnalyticsService()
